import React from "react";
import fetchData from "../api/Apicall";
import MovieRow from "./MovieRow";

const NowPlay = () => (
  <MovieRow title="Now Playing Movies" seeAllPath="/nowplay" fetcher={fetchData} />
);

export default NowPlay;
